export default {
  userCommunity: '用户社区'
}
